import { render, staticRenderFns } from "./viewdetailProduct.vue?vue&type=template&id=0d04d778&scoped=true&"
import script from "./viewdetailProduct.vue?vue&type=script&lang=js&"
export * from "./viewdetailProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d04d778",
  null
  
)

export default component.exports